<template>
  <div>
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="answer_number">
      <div><b>回答数 {{ answeredItemCount }}/{{ totalCountBySection }} <span>{{ progress }}%</span></b> <div class="progress_bar"><span :style="'width:' + progress + '%'"></span></div></div>
    </div>
    <ul class="ld-form">
    <li class="ld-form-item" v-for="(diagSubSection, index) in diagSection.sortedDiagSubSections" :key="diagSubSection.subSectionId" ref="itemRefs">
      <div class="ld-form-header" @click="clickHead(index)" >
        <div class="ld-form-header__title">
          <p class="number-text">
            <span class="number is-blue">{{ diagSubSection.sectionSortOrder }}-{{ diagSubSection.sortOrder }}</span>
            <span class="text">{{ diagSubSection.subSectionNm }}</span>
          </p>
        </div>
        <p class="ld-form-header__number">回答数 {{diagSubSection.answerCount}}/{{diagSubSection.totalCount}}</p>
      </div>

      <div class="ld-form-body" ref="itemBodyRefs">
        <template v-for="(diagItem, index2) in diagSubSection.sortedDiagItems">

          <div class="ld-form-content" :class="[diagItem.diagResultItem.itemVal ? 'is-answered is-check' : 'is-unanswered'] " :key="diagItem.itemId">
            <div class="ld-form-content__text" >
              <p class="number-text">
                <span class="number">{{ diagSubSection.sectionSortOrder }}-{{ diagSubSection.sortOrder }}-{{ diagItem.sortOrder }}</span>
                <span class="text">{{ diagItem.subjects }}</span>
              </p>
              <p class="check-item-text">{{ diagItem.checkItem }}</p>

              <div class="ld-form-btn-group" v-if="!isIpo || !diagItem.isMemo">
                <div v-if="diagItem.sampleComment != null && diagItem.sampleComment.length > 0" class="btn-hint" @click="displayDiagItemSampleComment(diagItem)"><span>現状/課題の例文</span></div>
                <div v-if="diagItem.remediation!=null && diagItem.remediation.length>0" class="btn-hint" @click="displayDiagItemRemediation(diagItem)"><span>ヒント・関連情報</span></div>
                <a class="link-arrow" @click="showEgovProvision(diagItem.diagResultItem.itemId)" :class="{'gray-out': !diagItem.provisionsDetail}">対応条文 e-Gov</a>
                <a class="link-arrow" @click="downloadGuideFile(diagItem.guideCd)" :class="{'gray-out': !diagItem.guideCd}">ガイド</a>
              </div>

              <transition name="slide-fade" @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave" @leave="leave">
                <div class="hinttxt is-open" v-show="diagItem.isDisplayRemediation">
                  <p>{{ diagItem.remediation }}</p>
                </div>
              </transition>

              <transition name="slide-fade" @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave" @leave="leave">
                <div class="hinttxt is-open" v-show="diagItem.isDisplaySampleComment">
                  <a class="link-arrow" @click="copyToClipboard(diagItem.sampleComment)">コピーする</a>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(diagItem.sampleComment)"></p>
                </div>
              </transition>
            </div>

            <div v-if="!isIpo || !diagItem.isMemo" class="ld-form-content__answer" style="width:600px;">
              <div class="ld-form-content__input">
                <label class="l-formGroup__label">回答</label>
                <RadioButton
                :options="selectList"
                v-model="diagItem.diagResultItem.itemVal"
                @input="() => emitChangeAnswer(diagItem)"
                ></RadioButton>
              </div>
              <div class="ld-form-content__memo" style="margin-bottom: 20px;">
                <label class="l-formGroup__label">現状/課題</label>
                <TextArea class="auto-height l-formGroup__textArea" v-model="diagItem.diagResultItem.remarks" @input="() => emitChangeAnswer(diagItem)"></TextArea>
              </div>
              <div class="ld-form-content__memo" style="margin-bottom: 10px;">
                <label class="l-formGroup__label"></label>
                <ValidationErrorMessage v-show="$v.diagSection.sortedDiagSubSections.$each[index].sortedDiagItems.$each[index2].diagResultItem.$error" validation="maxLength" valueLength="500" />
              </div>

              <!-- 資料URL-->
              <div class="ld-form-content__memo is-top" style="margin-bottom: 20px;">
                <div class="ld-form-content__memo-header">
                  <label class="l-formGroup__label u-mb10">資料URL<span class="icon-help url-help" data-tooltip="" style="cursor:pointer;" @click.stop="toggleUrlTooltip(diagItem.itemId)"><span class="tooltip is-top" :class="{ 'is-open': urlTooltipOpen[diagItem.itemId] }">関連資料のURLがあればご記入ください。監査中や振り返りの際にご活用いただけます。</span><img src="@/assets/img/common/icon-help.svg" alt="" width="16px"></span></label>
                  <button v-if="!urlForms[diagItem.itemId][0].viewFlag" class="link-arrow" @click="changeForm(diagItem.itemId, true)">編集する</button>
                  <button v-else class="link-arrow" @click="changeForm(diagItem.itemId, false)">編集を終わる</button>
                </div>
                <div class="ld-form-content__memo-body">
                  <div v-for="(form, index) in urlForms[diagItem.itemId]" :key="index">
                    <div v-if="!urlForms[diagItem.itemId][index].viewFlag" class="l-contentsMemo__body">
                      <div class="l-grayBox">
                        <p class="l-text" style="white-space: pre-line;" v-html="repalceLink(urlForms[diagItem.itemId][index].content)"></p>
                      </div>
                    </div>
                    <TextArea v-if="urlForms[diagItem.itemId][index].viewFlag" class="auto-height l-formGroup__textArea" v-model="urlForms[diagItem.itemId][index].content" @input="() => emitChangeAnswer(diagItem)"></TextArea>
                  </div>
                </div>
              </div> <!--資料URL end-->

              <button class="ld-form-detail-more_btn" :class="diagItem.diagResultItem.itemVal == 2 ? 'is-active' : ''" @click="displayDiagItemDetailInput(diagItem)">課題の詳細を記入</button>
            </div> <!--ld-form-content__answer end -->
            <div v-else class="ld-form-content__answer" style="width:600px;">
              <div class="ld-form-content__input"></div>
                <label class="l-formGroup__label">現状</label>
              <div class="ld-form-content__memo" style="margin-bottom: 20px;">
                <TextArea class="auto-height l-formGroup__textArea" v-model="diagItem.diagResultItem.remarks" @input="() => memoInput(diagItem)"></TextArea>
              </div>
              <div class="ld-form-content__memo" style="margin-bottom: 10px;">
                <label class="l-formGroup__label"></label>
                <ValidationErrorMessage v-show="$v.diagSection.sortedDiagSubSections.$each[index].sortedDiagItems.$each[index2].diagResultItem.$error" validation="maxLength" valueLength="500" />
              </div>
            </div>
          </div> <!--ld-form-content end-->

          <div class="ld-form-detail-more" :class="diagItem.isDisplayDetailInput ? 'is-open' : ''" :key="'detailInput'+diagItem.itemId">
            <div class="ld-form-detail-mode__header">
              <h4><span>課題タイトル</span> <span>{{ diagItem.task }}</span></h4>
            </div>
            <div class="l-contentsGrid2">
              <div class="l-contentsGrid2__item">
                <div>
                  <div class="l-formGroup">
                    <label class="l-formGroup__label">対応期限</label>
                    <div class="l-inputDate">
                      <DatePicker v-model="diagItem.diagResultItem.dueDate" :value="diagItem.diagResultItem.dueDate" @input="() => emitChangeAnswer(diagItem)"></DatePicker>
                    </div>
                    <label class="l-checkbox">
                      <CheckBox v-model="diagItem.diagResultItem.isHighPriority" :value="true"
                        :checked="diagItem.diagResultItem.isHighPriority"
                        @input="() => emitChangeAnswer(diagItem)"
                        labelText="優先度「高」"/>
                    </label>
                  </div>
                </div>
              </div>
              <div class="l-contentsGrid2__item">
                <div v-if="isIpo">
                  <div class="l-formGroup">
                    <label class="l-formGroup__label">改善の方向性</label>
                    <TextArea class="auto-height l-formGroup__textArea" v-model="diagItem.diagResultItem.laborConsultantCommentForIpo" @input="() => emitChangeAnswer(diagItem)"></TextArea>
                  </div>
                </div>
                <div v-else>
                  <div class="l-formGroup">
                    <label class="l-formGroup__label">改善の方向性</label>
                    <TextArea class="auto-height l-formGroup__textArea" v-model="diagItem.diagResultItem.laborConsultantComment" @input="() => emitChangeAnswer(diagItem)"></TextArea>
                  </div>
                </div>
              </div>
            </div>
            <button class="ld-form-detail-more_closebtn" @click="displayDiagItemDetailInput(diagItem)"><span>閉じる</span></button>
          </div>
        </template>
      </div>
    </li>
    </ul>
  </div>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import CheckBox from '@/components/parts/form/CheckBox.vue';
import DatePicker from '@/components/parts/form/DatePicker.vue';
import RadioButton from '@/components/parts/form/RadioButton.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import constant from '@/const';
import { saveAs } from "file-saver";
import { maxLength } from 'vuelidate/lib/validators';

export default {
  components: {
    Loading,
    RadioButton,
    TextArea,
    ValidationErrorMessage,
    DatePicker,
    CheckBox,
  },
  props: {
    diagSection: {
      sectionNm: '',
      sortedDiagSubSections: [
        {
          answerCount: 0,
          totalCount: 0,
          sortedDiagItems: [
            {
              diagResultItem: {
                itemVal: '',
                remarks: '',
                diagItem: '',
              },
            }
          ],
        }
      ],
    },
    isIpo:{type: Boolean},
    urlForms: [],
  },
  validations: {
    diagSection: {
      sortedDiagSubSections: {
        $each: {
          sortedDiagItems: {
            $each: {
              diagResultItem: {
                remarks: { maxLength: maxLength(500) }
              }
            }
          }
        }
      }
    }
  },
  data() {
    return {
      isProcessing: false,
      selectList: constant.DIAG_ANSWER_VALUE,
      answeredItemCount: 0,
      // 資料URLツールチップの表示状態(itemId単位、クリックでトグル)
      urlTooltipOpen: {}
    }
  },

  updated: function () {
    this.emitChangeAnswer();
  },
  beforeDestroy: function () {
    document.removeEventListener('click', this.closeUrlTooltip);
  },
  computed: {
    totalCountBySection() {
      let arr = [];
      let diagSubSections = this.diagSection.sortedDiagSubSections;

      let answeredItemCount=0;

      if (!diagSubSections) return 0;


      diagSubSections.forEach(function (diagSubSection) {

        let answerCount=0;
        let totalCount=0;
        diagSubSection.diagItems.forEach(function (diagItem) {

          if (diagItem.diagResultItem.itemVal !== "" && diagItem.diagResultItem.itemVal !== null) {

            answerCount++;
            answeredItemCount++;

          }
          arr.push(diagItem);
          totalCount++;
        })
        diagSubSection.answerCount = answerCount;
        diagSubSection.totalCount = totalCount;
      });
      this.updateAnsweredItemCount(answeredItemCount);

      return arr.length;
    },

    progress() {
      return Math.floor((this.answeredItemCount / this.totalCountBySection) * 100);
    }
  },
  methods: {
    changeForm(diagResultItemId, flag){
      this.urlForms[diagResultItemId].forEach((form) => {
        form.viewFlag = flag;
      });
    },
    // 資料URLのツールチップをクリックで表示/非表示トグル。
    // 開いた後は次にどこかがクリックされるまで開いたままにする
    // (?アイコン自身のクリックは @click.stop で document まで伝播させない)
    toggleUrlTooltip(itemId){
      const willOpen = !this.urlTooltipOpen[itemId];
      this.closeUrlTooltip();
      if (willOpen) {
        this.$set(this.urlTooltipOpen, itemId, true);
        document.addEventListener('click', this.closeUrlTooltip);
      }
    },
    // 開いているツールチップをすべて閉じる
    closeUrlTooltip(){
      Object.keys(this.urlTooltipOpen).forEach((key) => {
        if (this.urlTooltipOpen[key]) this.$set(this.urlTooltipOpen, key, false);
      });
      document.removeEventListener('click', this.closeUrlTooltip);
    },
    updateAnsweredItemCount(answeredItemCount) {
      this.answeredItemCount = answeredItemCount
    },

    // 現状/課題の例文の表示・非表示
    displayDiagItemSampleComment(diagItem) {
      diagItem.isDisplaySampleComment = !diagItem.isDisplaySampleComment;
      diagItem.isDisplayRemediation = diagItem.isDisplaySampleComment ? false : diagItem.isDisplaySampleComment;
    },
    // ヘルプの表示・非表示
    displayDiagItemRemediation(diagItem) {
      diagItem.isDisplayRemediation = !diagItem.isDisplayRemediation;
      diagItem.isDisplaySampleComment = diagItem.isDisplayRemediation ? false : diagItem.isDisplayRemediation;
    },
    displayDiagItemDetailInput(diagItem) {
      diagItem.isDisplayDetailInput = !diagItem.isDisplayDetailInput;
    },
    // メモ項目(isIpo && isMemo):現状/課題に入力があれば回答を対象外('4')に自動設定
    memoInput(dItem){
      if (!dItem) return;
      if (dItem.diagResultItem.remarks && dItem.diagResultItem.remarks.length > 0 ) {
        dItem['checked'] = true;
        dItem.diagResultItem.itemVal='4';
      }else{
        dItem['checked'] = false;
        dItem.diagResultItem.itemVal="";
      }
      this.emitChangeAnswer(dItem);
    },
    emitChangeAnswer(nullableDiagItem) {
      if (!nullableDiagItem) return;

      nullableDiagItem['checked'] = true;

      const diagItem = nullableDiagItem;
      if (diagItem.diagResultItem.itemVal != 2) {
        diagItem.diagResultItem.laborConsultantComment = null;
//        diagItem.diagResultItem.laborConsultantCommentForIpo = null;
        diagItem.diagResultItem.dueDate = null;
        diagItem.diagResultItem.isHighPriority = false;
        diagItem.isDisplayDetailInput = false;
      }

      let arr = [];
      let diagSubSections = this.diagSection.sortedDiagSubSections;

      if (!diagSubSections) return 0;

      diagSubSections.forEach(diagSubSection => {
        let answerCount=0;
        let totalCount=0;
        diagSubSection.sortedDiagItems.forEach(diagItem => {
          if (diagItem.diagResultItem.itemVal !== "") {
            answerCount++;
            arr.push(diagItem);
          }
          totalCount++;
        })
        diagSubSection.answerCount = answerCount;
        diagSubSection.totalCount = totalCount;
      });

      this.answeredItemCount = arr.length;
      this.$emit('change-answer', {
        answeredItemCount: this.answeredItemCount,
        totalCountBySection: this.totalCountBySection,
        progress: this.progress,
      })
    },
    beforeEnter: function(el) {
      el.style.height = '0';
    },
    enter: function(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    beforeLeave: function(el) {
      el.style.height = el.scrollHeight + 'px';
    },

    leave: function(el) {
      el.style.height = '0';
    },

    clickHead(index){
        if(this.$refs.itemRefs[index].className=="ld-form-item"){
            this.$refs.itemRefs[index].className="ld-form-item is-open";
            this.$refs.itemBodyRefs[index].style="display:block;";
        }else{
            this.$refs.itemRefs[index].className="ld-form-item";
            this.$refs.itemBodyRefs[index].style="display:none;";
        }
    },

    showEgovProvision(itemId) {
      this.$emit('show-egov', {itemId: itemId})
    },
    async downloadGuideFile(guideCd) {
      await saveAs('/ld/api/master/guide/downloadByGuideCd?guideCd=' + guideCd);
    },


    copyToClipboard (tagValue) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(tagValue);
        this.$toast.info('クリップボードに保存しました。');
      }
    },
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },

  }
}
</script>

<style scoped>
.slide-fade-enter-active {
    transition: height .1s ease-in-out;
}
.slide-fade-leave-active {
    transition: height .1s ease-in-out;
}

.slide-fade-enter-to, .slide-fade-leave {
   overflow: hidden;
}

.slide-fade-enter, .slide-fade-leave-to {
  overflow: hidden;
}

.gray-out {
  color: #a9a9a9;
  pointer-events: none;
}
.check-item-text {
  white-space: pre-line;
}
/* 資料URL 行。左カラム(ラベル＋?＋編集ボタン)＋本文の2カラム */
.ld-form-content__memo.is-top {
  align-items: flex-start;
}
.ld-form-content__memo-header {
  flex-shrink: 0;
  width: 100px;
}
/* ラベル列幅。入力欄(現状/課題・資料URL)の左端を縦に揃える */
.ld-form-content__memo .l-formGroup__label {
  width: 100px;
  margin-bottom: 0;
}
.ld-form-content__memo-header .icon-help {
  margin-left: 4px;
  vertical-align: middle;
  /* ツールチップ(.tooltip は position:absolute)の基準を ? アイコンにする */
  position: relative;
}
/* グローバルの .tooltip.is-top は left:auto のため矢印が ? からずれる。
   この行だけ ? の中央を基準に水平センタリングし、吹き出しの矢印が ? の真上に来るようにする */
.ld-form-content__memo-header .icon-help .tooltip.is-top {
  left: 50%;
  right: auto;
  transform: translateX(-50%) translateY(-105%);
}
/* クリックで開いている間は表示を維持する。
   共通処理(Top.vue等の $(document).click → $('.tooltip').fadeOut())が
   インラインで display:none / opacity を書き込むため !important で打ち消す */
.ld-form-content__memo-header .icon-help .tooltip.is-open {
  display: block !important;
  opacity: 1 !important;
}
.ld-form-content__memo-header .link-arrow {
  padding: 0;
}
.ld-form-content__memo-body {
  flex: 1;
}
</style>


